import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { hero, mainImage, smallHero as smallHeroStyle, heroInner, subTitle, title } from './hero.module.css';
import { cn } from '../../lib/helpers';

// backgroundImage should be a fluid image asset
const Hero = ({ smallHero, backgroundImage, siteTitle, siteSubtitle, imageAlt = 'Rides N Motion' }) => {
  return (
    <>
      <section className="hero">
        <div className={cn(mainImage, smallHero ? smallHeroStyle : null)}>
          {backgroundImage && (
            <GatsbyImage
              loading="eager"
              className={hero}
              image={backgroundImage}
              alt={imageAlt ? imageAlt : 'hero image'}
            />
          )}
          <div className={heroInner}>
            {siteSubtitle && <h3 dangerouslySetInnerHTML={{ __html: siteSubtitle }} className={subTitle} />}
            {siteTitle && <h1 dangerouslySetInnerHTML={{ __html: siteTitle }} className={title} />}
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
